(function() {
    'use strict';

    angular.module('machine.constants', [])
        .constant('machineMessagesConst', {
            add: 'Dodano nową maszynę!',
            update: 'Dane maszyny zostały zaktualizowane!',
            delete: 'Maszyna została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('machinePermissionsConst', {
            view: {
                value: 'view_machine',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu maszyn!'
            },
            add: {
                value: 'add_machine',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania maszyn!'
            },
            update: {
                value: 'change_machine',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji maszyn!'
            },
            delete: {
                value: 'delete_machine',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania maszyn!'
            }
        })
        .constant('machineactionPermissionsConst', {
            view: {
                value: 'view_machineaction',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu czynności maszyn!'
            },
            add: {
                value: 'add_machineaction',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania czynności maszyn!'
            },
            update: {
                value: 'change_machineaction',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji czynności maszyn!'
            },
            delete: {
                value: 'delete_machineaction',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania czynności maszyn!'
            }
        });
})();
